import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslationModeEnum } from 'src/app/common/enum/translation-mode-enum';
import { GenerateRouteService } from 'src/app/common/service/generate-route.service';
import { DemoRemoteService } from '../../service/demo-remote.service';
import { LoaderService } from 'src/app/common/service/loader.service';

@Component({
  selector: 'app-demo',
  templateUrl: './demo.component.html',
  styleUrl: './demo.component.scss'
})
export class DemoComponent implements OnInit {
  requesting: boolean = false;
  isHidden: boolean = false;
  emailUsed: boolean = false;
  translationModes: typeof TranslationModeEnum = TranslationModeEnum;
  demoForm: FormGroup;
  formSubmitted: boolean = false;
  contacted: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private generateRouteService: GenerateRouteService,
    private demoRemoteService: DemoRemoteService,
    private loaderService: LoaderService
  ) { }

  ngOnInit(): void {
    this.initForm();
  }

  /**
   * Controla el tiempo para la animación de la carpeta.
   */
  request(): void {
    this.requesting = true;
    setTimeout(() => {
      this.isHidden = true;
    }, 500);
  }

  /**
   * Inicializa el formulario.
   */
  initForm(): void {
    this.demoForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      termsAndConditions: [false, Validators.requiredTrue],
      receiveCommunications: [false]
    });
  }

  /**
   * Envía el formulario.
   */
  submitForm(): void {
    if (this.contacted) {
      this.demoForm.reset();
      this.formSubmitted = false;
      this.contacted = false;
      this.emailUsed = false;
    } else {
      this.formSubmitted = true;
      if (this.demoForm.valid) {
        // this.loaderService.showLoader();
        const requestData = {
          name: this.demoForm.get('name').value,
          email: this.demoForm.get('email').value,
          communications: this.demoForm.get('receiveCommunications').value
        };
        this.demoRemoteService.addNewDemo(requestData).subscribe(
          {
            next: (response) => {
              this.demoForm.reset();
              this.contacted = true;
              this.emailUsed = false;
              this.loaderService.hideLoader();
            },
            error: (error) => {
              if (error.code === 422) {
                this.emailUsed = true;
              }
              this.loaderService.hideLoader();
            },
            complete: () => { }
          }
        );
      }
    }
  }

  /**
   * Obtiene la ruta en función del idioma actual.
   * @param routeKey
   * @returns
   */
  getRouterLink(routeKey: any): string {
    return this.generateRouteService.generateRoute(routeKey);
  }
}
